/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1792540800000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Wed Oct 21 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "tiktok",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to TikTok",
          "depth": 0,
          "id": "connect-to-tiktok"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing web events",
          "depth": 1,
          "id": "syncing-web-events"
        }, {
          "value": "Syncing offline events",
          "depth": 1,
          "id": "syncing-offline-events"
        }, {
          "value": "Syncing app events",
          "depth": 1,
          "id": "syncing-app-events"
        }, {
          "value": "Syncing custom audiences",
          "depth": 1,
          "id": "syncing-custom-audiences"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Matched users count",
          "depth": 1,
          "id": "matched-users-count"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger-1"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      img: "img",
      h3: "h3",
      h4: "h4",
      code: "code",
      ul: "ul",
      li: "li",
      em: "em"
    }, _provideComponents(), props.components), {EventSyncWarning, MatchBoosterDestination, ArrayFanOutTip, MatchRatesExplanation, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!ArrayFanOutTip) _missingMdxReference("ArrayFanOutTip", true);
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!MatchBoosterDestination) _missingMdxReference("MatchBoosterDestination", true);
    if (!MatchRatesExplanation) _missingMdxReference("MatchRatesExplanation", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "With Hightouch and the TikTok marketing API, you can send data from your warehouse to events and custom audiences in TikTok.\nDeliver relevant ads by utilizing data from various sources within your data warehouse."
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported sync modes"
            }), _jsx(_components.th, {
              children: "API reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-web-events",
                children: _jsx(_components.strong, {
                  children: "Web events"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to TikTok's pixel events."
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://business-api.tiktok.com/portal/docs?id=1739289524101122",
                children: "Events API"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-offline-events",
                children: _jsx(_components.strong, {
                  children: "Offline events"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to TikTok's offline events."
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://ads.tiktok.com/marketing_api/docs?id=1758427539356673",
                children: "Offline Events API"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-app-events",
                children: _jsx(_components.strong, {
                  children: "App events"
                })
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to TikTok's app events."
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://business-api.tiktok.com/portal/docs?id=1740857868662786",
                children: "App Events API"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-custom-audiences",
                children: _jsx(_components.strong, {
                  children: "Custom audiences"
                })
              })
            }), _jsx(_components.td, {
              children: "Create audience lists and keep them up-to-date in TikTok."
            }), _jsx(_components.td, {
              children: "Add, All (file upload)"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://ads.tiktok.com/marketing_api/docs?id=1739940504185857",
                children: "Custom Audiences API"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-tiktok",
        children: "Connect to TikTok"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "TikTok"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to TikTok via OAuth."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-tiktok-oauth.png",
          alt: "Authenticating to TikTok in Hightouch"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Log in to TikTok"
        }), ", log in to your TikTok business account, and then click ", _jsx(_components.strong, {
          children: "Authorize"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've finished, Hightouch displays an ", _jsx(_components.strong, {
          children: "Authorization successful"
        }), " message. To finish connecting, give your TikTok destination a descriptive name."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've connected your TikTok destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the TikTok destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-web-events",
        children: "Syncing web events"
      }), "\n", _jsxs(_components.p, {
        children: ["Syncing to TikTok's ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/help/article?aid=10003669",
          children: "web events"
        }), " lets you report different events from your source model."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "pixel-code",
        children: "Pixel code"
      }), "\n", _jsxs(_components.p, {
        children: ["You need to provide your TikTok pixel code to sync web events. To find the pixel code, navigate to your ", _jsx(_components.a, {
          href: "https://ads.tiktok.com",
          children: "TikTok Marketing Dashboard"
        }), "\nand go to ", _jsx(_components.strong, {
          children: "Assets menu"
        }), " > ", _jsx(_components.strong, {
          children: "Manage Web Events"
        }), ". Select the pixel you want to sync to and copy the ID."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["Check out our ", _jsx(_components.a, {
            href: "https://hightouch.com/blog/what-is-a-tiktok-pixel",
            children: "blog post"
          }), "\nto learn how to implement a TikTok Pixel to help track conversions."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "event-name",
        children: "Event name"
      }), "\n", _jsx(_components.p, {
        children: "You can set the event name to a static value or map it from a column in your model. You can select one of these event names:\nAddPaymentInfo, AddToCart, AddToWishlist, ApplicationApproval, ClickButton, CompletePayment, CompleteRegistration, Contact,\nCustomizeProduct, Download, FindLocation, InitiateCheckout, Lead, PlaceAnOrder, Purchase, Schedule, Search, StartTrial,\nSubmitApplication, SubmitForm, Subscribe, or ViewContent."
      }), "\n", _jsx(_components.p, {
        children: "To send a custom event, type its name instead."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can send additional details on your web events such as the timestamp, event (object) properties, and context (customer) properties.\nTikTok recommends that you provide as much context information as possible to increase probability of matching\nweb events with TikTok ads."
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["If mapping the ", _jsx(_components.code, {
            children: "Click Id"
          }), " field, TikTok recommends that you also send the\n", _jsx(_components.code, {
            children: "Page url"
          }), " field for best results."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "batch-size",
        children: "Batch size"
      }), "\n", _jsx(_components.p, {
        children: "You can increase the TikTok events API batch size up to 1,000 per call. This can improve your\nsync's speed performance. The default is one event per API call. Keep in mind that\nTikTok fails an entire batch if it detects an erroneous row. If you suspect\nthat you could have erroring rows, don't use a high batch size."
      }), "\n", _jsx(_components.h4, {
        id: "test-event-codes",
        children: "Test event codes"
      }), "\n", _jsx(_components.p, {
        children: "Test event codes are special codes you can include in your event payload to simulate events. This allows you to test your API implementation without actually recording real event data."
      }), "\n", _jsxs(_components.p, {
        children: ["You can optionally enter a test event code as part of your sync configuration. Navigate to ", _jsx(_components.strong, {
          children: "Events Manager"
        }), " by clicking the ", _jsx(_components.strong, {
          children: "Assets"
        }), " tab, ", _jsx(_components.strong, {
          children: "Event"
        }), " and then ", _jsx(_components.strong, {
          children: "Manage Web Events"
        }), ". You can find your test event code in the ", _jsx(_components.strong, {
          children: "Test Events"
        }), " tab."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-tiktok-test-event-code.png",
          alt: "Test event code in TikTok Events Manager"
        })
      }), "\n", _jsx(_components.p, {
        children: "Make sure to remove the test event code if you're running a production sync."
      }), "\n", _jsx(_components.h4, {
        id: "pii-hashing",
        children: "PII hashing"
      }), "\n", _jsx(_components.p, {
        children: "TikTok requires customer identity information (email, external_id, and phone_number) to be hashed using a SHA256 hash.\nBy default, Hightouch automatically hashes these properties for you but you can choose to opt out of this and\nhash the identity information yourself."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-offline-events",
        children: "Syncing offline events"
      }), "\n", _jsxs(_components.p, {
        children: ["Syncing to TikTok's ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1758427539356673",
          children: "offline events"
        }), " lets you\ntrack and measure offline activity from people that see or interact with your ads."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["Syncing offline events is an allowlist-only feature in TikTok. If you want\naccess, please contact your TikTok representative. If you initially configured\nyour TikTok destination before 06/06/23, you need to\n", _jsx(_components.a, {
            href: "#connect-to-tiktok",
            children: "re-authenticate"
          }), " your connection to TikTok."]
        })
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "event-set-id",
        children: "Event set ID"
      }), "\n", _jsx(_components.p, {
        children: "You need to select an event set ID to sync your offline events. You can create a new event set in your TikTok offline events manager dashboard."
      }), "\n", _jsx(_components.h4, {
        id: "event-name-1",
        children: "Event name"
      }), "\n", _jsx(_components.p, {
        children: "You can set the event name to a static value or map it from a column in your model. You can select one of these event names:\nAddPaymentInfo, AddToCart, AddToWishlist, ApplicationApproval, ClickButton, CompletePayment, CompleteRegistration, Contact,\nCustomizeProduct, Download, FindLocation, InitiateCheckout, Lead, PlaceAnOrder, Purchase, Schedule, Search, StartTrial,\nSubmitApplication, SubmitForm, Subscribe, or ViewContent."
      }), "\n", _jsx(_components.p, {
        children: "To send a custom event, type its name instead."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You need, at minimum, the event name and at least one user property, emails or phones. The emails and phones array values must include at least one value,\nbut you can include multiple elements. If you have single email or phone number as strings in a model column, Hightouch converts them into arrays with one element."
      }), "\n", _jsx(_components.h4, {
        id: "batch-size-1",
        children: "Batch size"
      }), "\n", _jsx(_components.p, {
        children: "You can increase the TikTok events API batch size up to 100 per call. This can improve your\nsync's speed performance. The default is 100 events per API call. Keep in mind that\nTikTok fails an entire batch if it detects an erroneous row. If you suspect\nthat you could have erroring rows, don't use a high batch size."
      }), "\n", _jsx(_components.h4, {
        id: "pii-hashing-1",
        children: "PII hashing"
      }), "\n", _jsx(_components.p, {
        children: "TikTok requires user identity information (emails and phone_numbers) to be hashed using a SHA256 hash.\nBy default, Hightouch automatically hashes these properties for you but you can choose to opt out of this and\nhash the identity information yourself."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-app-events",
        children: "Syncing app events"
      }), "\n", _jsxs(_components.p, {
        children: ["Syncing to TikTok's ", _jsx(_components.a, {
          href: "https://business-api.tiktok.com/portal/docs?id=1740857868662786",
          children: "app events"
        }), " lets you\ntrack mobile app activity like launching the app or in-app purchases."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["Syncing app events is an allowlist-only feature in TikTok. If you want access,\nplease contact your TikTok representative. If you initially configured your\nTikTok destination before 06/06/23, you need to\n", _jsx(_components.a, {
            href: "#connect-to-tiktok",
            children: "re-authenticate"
          }), " your connection to TikTok."]
        })
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "tiktok-app-id",
        children: "TikTok app ID"
      }), "\n", _jsxs(_components.p, {
        children: ["You need to select an app ID to sync your app events. You can create a new app set in your TikTok ads manager dashboard.\nTo learn about how to generate a TikTok App ID, see ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/help/article/how-to-generate-a-tiktok-app-id",
          children: "TikTok App ID"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "event-name-2",
        children: "Event name"
      }), "\n", _jsx(_components.p, {
        children: "You can set the event name to a static value or map it from a column in your model. You can select one of these event names:\nAddPaymentInfo, AddToCart, AddToWishlist, ApplicationApproval, ClickButton, CompletePayment, CompleteRegistration, Contact,\nCustomizeProduct, Download, FindLocation, InitiateCheckout, Lead, PlaceAnOrder, Purchase, Schedule, Search, StartTrial,\nSubmitApplication, SubmitForm, Subscribe, or ViewContent."
      }), "\n", _jsx(_components.p, {
        children: "To send a custom event, type its name instead."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can send additional details on your app events such as the timestamp, event properties, and context properties.\nTikTok recommends that you provide as much context information as possible to increase the probability of matching\napp events with TikTok ads."
      }), "\n", _jsx(_components.h4, {
        id: "batch-size-2",
        children: "Batch size"
      }), "\n", _jsx(_components.p, {
        children: "You can increase the TikTok events API batch size up to 100 per call. This can improve your\nsync's speed performance. The default is 100 events per API call. Keep in mind that\nTikTok fails an entire batch if it detects an erroneous row. If you suspect\nthat you could have erroring rows, don't use a high batch size."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-custom-audiences",
        children: "Syncing custom audiences"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you create and maintain custom audiences via the ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1739940501023746",
          children: "File upload API"
        }), " or ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1739940504185857",
          children: "Segment API"
        }), ".\nYou can read more on the different APIs and decide which is best for your use case in ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1739566528222210",
          children: "TikTok's docs"
        }), "."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "segment-api-mode-recommended",
        children: "Segment API mode (Recommended)"
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["TikTok lets you make real-time batch updates through their ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1739940504185857",
          children: "Segment API"
        }), ". Hightouch sends data to the selected audience list\nas data gets added in your source model. We recommend this integration type because the API is newer and the integration is maintained by our team."]
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "To identify which users to add or update in an audience, select model columns and the corresponding Tiktok fields. You can match on any of the following hashed user fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "IDFA_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "IDFA_MD5"
        }), "\n", _jsx(_components.li, {
          children: "GAID_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "GAID_MD5"
        }), "\n", _jsx(_components.li, {
          children: "EMAIL_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "PHONE_SHA256"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Hightouch automatically hashes the selected properties for you unless you specify otherwise."
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "TikTok"
      }), "\n", _jsx(ArrayFanOutTip, {
        destinationName: "TikTok"
      }), "\n", "\n", _jsx(_components.h4, {
        id: "file-upload-api-mode-deprecated",
        children: "File upload API mode (Deprecated)"
      }), "\n", "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "While TikTok still supports this API, Hightouch has deprecated the\nintegration. We no longer add enhancements to the File upload API, and by end\nof 2023, we will programmatically migrate existing syncs to the Segment API\nmode and fully sunset this functionality."
        })
      }), "\n", _jsxs(_components.p, {
        children: ["TikTok lets you upload an entire audience through their ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1739940567842818",
          children: "file upload API"
        }), ". Hightouch uploads the entire model query results for each sync run.\nThese results effectively replaces the previous file upload."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "The File upload mode lets you match on any one of these hashed user properties:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "IDFA_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "IDFA_MD5"
        }), "\n", _jsx(_components.li, {
          children: "GAID_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "GAID_MD5"
        }), "\n", _jsx(_components.li, {
          children: "EMAIL_SHA256"
        }), "\n", _jsx(_components.li, {
          children: "or PHONE_SHA256"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "The property contains the name of what type of hash TikTok expects. Hightouch\nautomatically hashes the selected property for you unless you specify otherwise. Hightouch also creates the audience list,\nif it doesn't exist yet, with the selected property's hash type."
      }), "\n", _jsx(_components.h4, {
        id: "advertiser-account",
        children: "Advertiser account"
      }), "\n", _jsx(_components.p, {
        children: "For both modes, you need to select the advertiser account you want to sync to."
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "Editing the advertiser account in the sync configuration is only possible\nbefore triggering the first sync run. Otherwise, making this change results in\nan error. If you want to use a different advertiser account once the sync has\nalready run, you need to create a new sync."
        })
      }), "\n", _jsx(_components.h4, {
        id: "custom-audience-list",
        children: "Custom audience list"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch lets you use an existing audience in TikTok or create a new one for both modes. Note that if you're using Segment mode, you can't\nchange your audience list name once your sync has run, instead, you will have to create a new sync."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["For Hightouch platform error codes related to TikTok, see ", _jsx(_components.a, {
            href: "/developer-tools/error-codes#tiktok",
            children: "Error codes: TikTok"
          }), "."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "matched-users-count",
        children: "Matched users count"
      }), "\n", _jsx(_components.p, {
        children: "Below only applies to the custom audiences sync type."
      }), "\n", _jsx(MatchRatesExplanation, {
        destination: "TikTok Ads"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "custom-audiences",
        children: "Custom audiences"
      }), "\n", _jsxs(_components.p, {
        children: ["If you want to switch your custom audience sync mode from ", _jsx(_components.a, {
          href: "#file-upload-api-mode-deprecated",
          children: "File upload API"
        }), " to ", _jsx(_components.a, {
          href: "#segment-api-mode-recommended",
          children: "Segment API"
        }), ", you need to run a ", _jsx(_components.a, {
          href: "/syncs/overview#resync-full-query",
          children: "full resync"
        }), " after saving the new configuration."]
      }), "\n", _jsx(_components.h4, {
        id: "error-40001-no-permission-to-operate-advertiser",
        children: "Error 40001: No permission to operate advertiser"
      }), "\n", _jsxs(_components.p, {
        children: ["This error can happen if the TikTok user credentials used to ", _jsx(_components.a, {
          href: "#connect-to-tiktok",
          children: "connect to TikTok"
        }), " don't have the necessary permissions to send data to the ", _jsx(_components.a, {
          href: "#advertiser-account",
          children: "advertiser account"
        }), " selected in the sync configuration. When this error happens, you might also see that the advertiser account dropdown menu in the sync configuration is empty."]
      }), "\n", _jsx(_components.p, {
        children: "To solve this, make sure that the credentials used to connect TikTok to Hightouch have the necessary permissions to send data to your advertiser accounts."
      }), "\n", _jsx(_components.h4, {
        id: "file-upload-api-mode",
        children: "File upload API mode"
      }), "\n", _jsxs(_components.p, {
        children: ["Audiences with fewer than 1000 users are invalid and won't be available in TikTok. For more information, please refer to ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/help/article?aid=9611",
          children: "TikTok's documentation"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["TikTok allows one file-based audience upload per day per audience. See TikTok's ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1708580518247426",
          children: "docs"
        }), " for more information on their limits."]
      }), "\n", _jsx(_components.h4, {
        id: "web-events",
        children: "Web events"
      }), "\n", _jsxs(_components.p, {
        children: ["Most errors that occur with web event syncs are validation errors, like an invalid currency code or phone number. TikTok rejects any requests with invalid data, so Hightouch preemptively rejects these rows to make syncs run more efficiently. Please refer to TikTok's ", _jsx(_components.a, {
          href: "https://ads.tiktok.com/marketing_api/docs?id=1740858565852225",
          children: "documentation"
        }), " to learn more about the expected phone number format and currency codes."]
      }), "\n", _jsx(Info, {
        children: "TikTok may update their currency code list."
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch provides complete visibility into the API calls made during each of your TikTok sync runs, ", _jsx(_components.em, {
          children: "except for syncs in custom audience file upload mode"
        }), ". In this mode, Hightouch syncs the full query results set, and therefore doesn't make a ", _jsx(_components.a, {
          href: "/getting-started/concepts#change-data-capture-cdc",
          children: "change data capture computation"
        }), ". As a result, you won't see any payload details in the ", _jsx(_components.a, {
          href: "/syncs/debugger#payload-inspection",
          children: "Live debugger"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["For the web event and custom audience segment mode syncs, we recommend reading our ", _jsx(_components.a, {
          href: "/syncs/debugger",
          children: "article on debugging tips and tricks"
        }), " to learn more."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger-1",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
